const CIIU_MODULE_IDS = [1, 2, 4];
const PROBLEM_MODULE_IDS = [3];
const ORGANISM_MODULE_IDS = [5];
const OPERATION_SIZE_MODULE_IDS = [6];
const TOPIC_MODULE_IDS = [7];

export const getModuleWorkAxis = (moduleOrId) => {
  const id = Number(moduleOrId?.id || moduleOrId || 0);
  if (CIIU_MODULE_IDS.includes(id)) {
    return "ciiu_l1";
  }
  if (PROBLEM_MODULE_IDS.includes(id)) {
    return "problem";
  }
  if (ORGANISM_MODULE_IDS.includes(id)) {
    return "organism";
  }
  if (OPERATION_SIZE_MODULE_IDS.includes(id)) {
    return "operation_size";
  }
  if (TOPIC_MODULE_IDS.includes(id)) {
    return "topic";
  }
  return "none";
};

export const isSegmentingWorkAxis = (axis) => axis && axis !== "none";
